export const screenshots: IScreenshotsPerFlavour = {
    normal: {
        desktop: {
            large: {
                width: 1000,
                height: 1097.3958333333333,
                ratio: 0.9112482202183199,
                url: 'https://storage.googleapis.com/download/storage/v1/b/life-b033c.appspot.com/o/screenshots%2Fscreenshot.gdi.apps-basic.normal.desktop.large.webp?alt=media',
                urlIsRemote: true,
            },
            thumb: {
                width: 400,
                height: 438.95833333333337,
                ratio: 0.9112482202183199,
                url: 'https://storage.googleapis.com/download/storage/v1/b/life-b033c.appspot.com/o/screenshots%2Fscreenshot.gdi.apps-basic.normal.desktop.thumb.webp?alt=media',
                urlIsRemote: true,
            },
        },
        mobile: {
            large: {
                width: 500,
                height: 877.9166666666667,
                ratio: 0.5695301376364499,
                url: 'https://storage.googleapis.com/download/storage/v1/b/life-b033c.appspot.com/o/screenshots%2Fscreenshot.gdi.apps-basic.normal.mobile.large.webp?alt=media',
                urlIsRemote: true,
            },
            thumb: {
                width: 200,
                height: 351.1666666666667,
                ratio: 0.5695301376364499,
                url: 'https://storage.googleapis.com/download/storage/v1/b/life-b033c.appspot.com/o/screenshots%2Fscreenshot.gdi.apps-basic.normal.mobile.thumb.webp?alt=media',
                urlIsRemote: true,
            },
        },
    },
};
